import { QueryFunction, QueryKey, UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import { useCallback, useState } from 'react';

export function useLazyQuery<TData, TError>(
  key: QueryKey,
  fetchFn: QueryFunction<TData, QueryKey>,
  options?: Omit<UseQueryOptions<TData, TError, TData, QueryKey>, 'queryKey' | 'queryFn'>,
): [() => void, UseQueryResult<TData, TError>] {
  const [enabled, setEnabled] = useState(false);

  const query = useQuery<TData, TError, TData, QueryKey>({
    queryKey: key,
    queryFn: fetchFn,
    ...(options || {}),
    enabled,
  });

  const trigger = useCallback(() => {
    if (!enabled) {
      setEnabled(true);
    }
  }, [enabled]);

  return [trigger, query];
}
